import { render, staticRenderFns } from "./LegalEntityProfilePublic.vue?vue&type=template&id=354715c5&scoped=true&"
import script from "./LegalEntityProfilePublic.vue?vue&type=script&lang=js&"
export * from "./LegalEntityProfilePublic.vue?vue&type=script&lang=js&"
import style0 from "./LegalEntityProfilePublic.vue?vue&type=style&index=0&id=354715c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354715c5",
  null
  
)

export default component.exports